export default __webpack_public_path__ + "68a239767eb223f076084ee30d2e7d1d.webp";